export default "__VITE_ASSET__BF8ScGs2__"